// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { setAppStateSliceKey } from './app-state.actions';
export const appStateSliceKey = createReducer('', on(setAppStateSliceKey, (state, action) => {
    return action.stateSliceKey;
}));
